import { ITemplate } from '../types';
import { ITemplatesSet } from './types';
import { TEMPLATES_SET } from './constants';

export const templatesSet = (
    templates: ITemplate[]
): ITemplatesSet => ({
    type: TEMPLATES_SET,
    templates
});
